module.exports = __webpack_public_path__ + "static/media/bgimage.e3863dc8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/revised/bgimage.png
// module id = 369
// module chunks = 0